<template>
  <div class="container">
    <div class="loading" v-if="loading">
      <Loading />
    </div>
    <!-- <CardData v-show="!loading" /> -->

    <div class="div-title" v-show="!loading">
      <h4 class=" title">
        Total {{ this.year }} - Datos agregados (de todo el Estado central)
      </h4>
      <h5 class="title">
        Dotación total año {{ this.year }}:
        {{ this.personasTotales }}
      </h5>
    </div>

    <div v-show="!loading">
      <details open>
        <summary>
          Dotación de Personal por Tipo de relación laboral
          {{ this.year }}
        </summary>
        <div class="data">
          <TortaData :datos="this.relacionLaboral" />
        </div>
      </details>

      <details>
        <summary>
          Dotación de personal por tipo de relación laboral y género año
          {{ this.year }}
        </summary>
        <div>
          <Data :datos="this.contratoGenero" />
        </div>
      </details>

      <!-- collapse tres -->
      <details>
        <summary>
          Dotación de personal por estamento año
          {{ this.year }}
        </summary>
        <div>
          <DataDotacion :datos="this.estamentoGenero" />
        </div>
      </details>
      <!-- collapse cuatro -->
      <details>
        <summary>
          Dotación de pérsonal por la edad
          {{ this.year }}
        </summary>
        <div>
          <CollapseEdad :datos="this.dotacionEdad" />
        </div>
      </details>
    </div>
  </div>
</template>

<script>
import Data from "../data/Data.vue";
import DataDotacion from "../data/DataDotacion.vue";
// import CardData from "../card/CardData.vue";
import CollapseEdad from "../data/CollpaseEdad.vue";
import TortaData from "../data/TortaData.vue";
import Loading from "../../../../components/tools/Loading.vue";
import { mapGetters } from "vuex";
import axios from "axios";
// import { maxData } from "../../../../components/tools/utils";
export default {
  components: {
    Data,
    DataDotacion,
    CollapseEdad,
    // CardData,
    TortaData,
    Loading,
  },

  data() {
    return {
      relacionLaboral: null,
      estamentoGenero: null,
      contratoGenero: null,
      dotacionEdad: null,
      loading: true,
      // percMujer: 0,
      // percContrata: 0,
      // toShow: [],
    };
  },

  computed: {
    ...mapGetters(["year", "personasTotales"]),
  },

  methods: {
    getData: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/total/?anio=${this.year}&tipo=1`
        );

        const datos = res.data[0].datos;

        let totalPersonas = 0;
        this.$store.commit("addPersonasTotales", -1 * this.personasTotales);
        Object.keys(datos.cJuridica).forEach((i) => {
          totalPersonas += datos.cJuridica[i];
        });
        
        this.$store.commit("addPersonasTotales", totalPersonas);

        this.relacionLaboral = {
          labels: Object.keys(datos.cJuridica),
          data: Object.keys(datos.cJuridica).map((i) => datos.cJuridica[i]),
        };
        this.sortData(this.relacionLaboral);

        this.dotacionEdad = {
          labels: Object.keys(datos.grupoEdad).map((i) =>
            i.replace("ENTRE", "").replace("AÑOS", "")
          ),
          data: {
            values: Object.keys(datos.grupoEdad).map((i) => datos.grupoEdad[i]),
            perc: Object.keys(datos.grupoEdad).map((i) => (
              this.roundPerc((datos.grupoEdad[i]*100)/this.personasTotales)
            ))
          },
        };
        var first = this.dotacionEdad.labels.shift();
        this.dotacionEdad.labels.push(first);
        first = this.dotacionEdad.data.values.shift();
        this.dotacionEdad.data.values.push(first);
        first = this.dotacionEdad.data.perc.shift();
        this.dotacionEdad.data.perc.push(first);

        this.contratoGenero = {
          labels: Object.keys(datos.cJuridicaSexo),
          data: {
            h: Object.keys(datos.cJuridicaSexo).map(
              (d) => datos.cJuridicaSexo[d]["H"] ?? 0
            ),
            m: Object.keys(datos.cJuridicaSexo).map(
              (d) => datos.cJuridicaSexo[d]["M"] ?? 0
            ),
            perc: {
              h: Object.keys(datos.cJuridicaSexo).map(
                (d) => this.roundPerc((datos.cJuridicaSexo[d]["H"]*100)/datos.cJuridica[d]) ?? 0
              ),
              m: Object.keys(datos.cJuridicaSexo).map(
                (d) => this.roundPerc((datos.cJuridicaSexo[d]["M"]*100)/datos.cJuridica[d]) ?? 0
              ),
            },
          },
        };
        this.sortDataGenero(this.contratoGenero);

        this.estamentoGenero = {
          labels: Object.keys(datos.estamentosSexo),
          data: {
            h: Object.keys(datos.estamentosSexo).map(
              (d) => datos.estamentosSexo[d]["H"] ?? 0
            ),
            m: Object.keys(datos.estamentosSexo).map(
              (d) => datos.estamentosSexo[d]["M"] ?? 0
            ),
            perc: {
              h: Object.keys(datos.estamentosSexo).map(
                (d) => this.roundPerc((datos.estamentosSexo[d]["H"]*100)/datos.estamentos[d]) ?? 0
              ),
              m: Object.keys(datos.estamentosSexo).map(
                (d) => this.roundPerc((datos.estamentosSexo[d]["M"]*100)/datos.estamentos[d]) ?? 0
              ),
            },
          },
        };
        this.sortDataGenero(this.estamentoGenero);
        this.loading = false;
        // this.highestData();
      } catch (error) {
        console.log(error);
      }
    },
    sortData: function(toSort) {
      var data = toSort.data;
      var labels = toSort.labels;
      var l = labels.length,
        tmp,
        tmp2;
      for (let i = 0; i < l; i++) {
        for (let j = 0; j < l - 1 - i; j++) {
          if (data[j] < data[j + 1]) {
            tmp = data[j];
            data[j] = data[j + 1];
            data[j + 1] = tmp;

            tmp2 = labels[j];
            labels[j] = labels[j + 1];
            labels[j + 1] = tmp2;
          }
        }
      }
    },
    sortDataGenero: function(toSort) {
      var data = toSort.data;
      var labels = toSort.labels;
      var l = labels.length,
        dataTemp,
        labelsTemp;
      for (let i = 0; i < l; i++) {
        for (let j = 0; j < l - 1 - i; j++) {
          if (data.h[j] < data.h[j + 1] && data.m[j] < data.m[j + 1]) {
            labelsTemp = labels[j];
            labels[j] = labels[j + 1];
            labels[j + 1] = labelsTemp;

            dataTemp = data.h[j];
            data.h[j] = data.h[j + 1];
            data.h[j + 1] = dataTemp;

            dataTemp = data.m[j];
            data.m[j] = data.m[j + 1];
            data.m[j + 1] = dataTemp;

            dataTemp = data.perc.h[j];
            data.perc.h[j] = data.perc.h[j + 1];
            data.perc.h[j + 1] = dataTemp;

            dataTemp = data.perc.m[j];
            data.perc.m[j] = data.perc.m[j + 1];
            data.perc.m[j + 1] = dataTemp;
          }
        }
      }
    },
    // highestData: function() {
    //   let contratoGeneroHighest, estamentoGeneroHighest; //, edadHighest;
    //   if (this.contratoGenero.data.h[0] > this.contratoGenero.data.m[0]) {
    //     contratoGeneroHighest = this.contratoGenero.data.h[0];
    //   } else {
    //     contratoGeneroHighest = this.contratoGenero.data.m[0];
    //   }
    //   this.contratoGenero.highestValue = maxData(contratoGeneroHighest);

    //   if (this.estamentoGenero.data.h[0] > this.estamentoGenero.data.m[0]) {
    //     estamentoGeneroHighest = this.estamentoGenero.data.h[0];
    //   } else {
    //     estamentoGeneroHighest = this.estamentoGenero.data.m[0];
    //   }
    //   this.estamentoGenero.highestValue = maxData(estamentoGeneroHighest);

    //   let mayor = 0;
    //   this.dotacionEdad.data.values.forEach((i) => {
    //     if (i > mayor) {
    //       mayor = i;
    //     }
    //   });
    //   this.dotacionEdad.highestValue = maxData(mayor);
    // },
    roundPerc: function(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100
    }
  },

  watch: {
    year: async function() {
      this.getData();
    },
    // dotacionEdad: function() {
    //   console.log(this.dotacionEdad);
    // },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");

*,
*:after,
*:before {
  box-sizing: border-box;
}

.div-title {
  margin-top: 25px;
  margin-bottom: 20px;
}
.title {
  /* font-size: 20px; */
  color: #052333;
  margin-left: 50px;
  font-weight: 600;
}
.loading {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.row {
  margin: 0;
}

.data {
  justify-content: center;
  align-items: center;
}

:root {
  font-size: 16px;
}

body {
  font-family: "Fira Sans", sans-serif;
  line-height: 1.5;
  min-height: 100vh;
  font-size: 1.25rem;
}

*:focus {
  outline: none;
}

body > div {
  width: 90%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5rem;
  margin-bottom: 5rem;
}

data {
  padding: 2.5em;
}

data > * + * {
  margin-top: 1.5em;
}

details + details {
  margin-top: 20px;
  margin-bottom: 20px;
}

summary {
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}

summary {
  padding: 0.75em 1em;
  cursor: pointer;
  position: relative;
  padding-left: calc(1.75rem + 0.75rem + 0.75rem);
  background: #e0e0e0;
  font-weight: 600;
}

/* summary:before {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: .75rem;
	content: "↓";
	width: 1.75rem;
	height: 1.75rem;
	background-color: #000;
	color: #FFF;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
} */

details[open] summary {
  background-color: #eee;
}

details[open] summary:before {
  content: "↑";
}

summary:hover {
  background-color: #eee;
}

a {
  color: inherit;
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 1px 0 0;
}

a:hover {
  box-shadow: 0 3px 0 0;
}

code {
  font-family: "Fira Sans", sans-serif;
  font-weight: 600;
}
</style>
